import React, { useEffect } from 'react'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getUser } from '@verzekeringapp-mono/shared/src/state/selectors/user'
import {
  getWhatToDos as getWhatToDosSelector,
  getFlashNews as getFlashNewsSelector
} from '@verzekeringapp-mono/shared/src/state/selectors/support'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import UserInfo from './components/user_info'
import NavigationButton from './components/navigation_button'
import ContentSection from './components/content_section'
import { useSupport } from '@verzekeringapp-mono/shared/src/hooks/use_support'
import { getWhatToDoItemIconName } from '@verzekeringapp-mono/shared/src/models/what_to_do'
import FlashNews from './components/flash_news'
import ClaimDamageButton from '~/components/ClaimDamageButton'
import SETTINGS from '@verzekeringapp-mono/shared/src/constants/settings'
import IllustrationClaims from '~/components/illustrations/IllustrationClaims'
import { useEmergencyModalContext } from '~/providers/EmergencyModalProvider'
import { getResourceAuthorization } from '@verzekeringapp-mono/shared/src/state/selectors/resource_authorization'
import usePolicies from '@verzekeringapp-mono/shared/src/hooks/use_policies'
import useProducts from '@verzekeringapp-mono/shared/src/hooks/use_product'
import MyPoliciesCard from './components/my_policies_card'

const HomeScreen: React.FC = () => {
  const { getPolicies } = usePolicies()
  const { getProducts, getAdviceProducts } = useProducts()
  const { open } = useEmergencyModalContext()
  const user = useAppSelector(getUser)

  const whatToDos = useAppSelector(getWhatToDosSelector)
  const flashNews = useAppSelector(getFlashNewsSelector)
  const { getWhatToDos, getFlashNews } = useSupport()

  const resourceAuthorization = useAppSelector(getResourceAuthorization)

  useEffect(() => {
    getPolicies()
    getProducts()
    getAdviceProducts()
    getWhatToDos()
    getFlashNews()
  }, [])

  return (
    <ScreenWrapper
      hasPadding={false}
      breadCrumbsOverride={[]}
    >
      <div>
        <div className='gap-4 flex justify-between px-3 mb-0 md:mb-8 items-center md:items-start'>
          <div className='w-full xl:w-4/6'>
            <UserInfo firstName={user?.firstName ?? ''} />
          </div>

          <div className='hidden w-2/6 max-w-[300px] text-center text-icon-brand xl:block'>
            <IllustrationClaims />
          </div>

          <div className='md:hidden w-fits h-fit p-4'>
            <img
              src={`${resourceAuthorization?.relationInfo?.logo}?${Date.now()}`}
              alt='Logo'
              className=' w-20 h-20 object-contain'
            />
          </div>
        </div>

        <div className='grid grid-cols-1 xl:grid-cols-3 gap-8 md:mt-8 px-4 md:px-0'>
          <MyPoliciesCard />

          <ContentSection
            icon='fragile'
            title='Schade melden'
            className='xl:col-span-1'
          >
            <>
              <p className='mb-4'>
                Heb je schade? Vul het schadeformulier in via onderstaande
                button. Je adviseur neemt de schade vervolgens z.s.m. in
                behandeling!
              </p>

              <ClaimDamageButton/>

              <p className='mt-4'>In geval van nood, neem contact op via het noodnummer: </p>

              <a
                onClick={open}
                className='text-status-danger-foreground'
              >
                {SETTINGS.emergencyPhoneNumber}
              </a>
            </>
          </ContentSection>
        </div>

        <div className='px-4 grid grid-cols-1 xl:grid-cols-3 gap-8 mt-8 md:px-0'>
          <ContentSection
            title='Schadehersteller'
            icon='tools'
          >
            <NavigationButton
              text='Voertuigschade'
              icon='car'
              href='/schadehersteller/voertuigschade'
            />
          </ContentSection>

          <ContentSection
            title='Mijn dossier'
            icon='folder'
          >
            <NavigationButton
              text='Mijn schades'
              icon='fragile'
              href='/dossier/mijn-schades'
            />

            <NavigationButton
              text='Mijn betaaloverzicht'
              icon='euro-sign'
              href='/dossier/betalingsoverzicht'
            />
          </ContentSection>

          <ContentSection
            title='Wat te doen bij'
            icon='question'
          >
            {!!whatToDos &&
              !!(whatToDos.length > 0) &&
              whatToDos.map(whatToDo => (
                <NavigationButton
                  key={whatToDo.id}
                  text={whatToDo.subject}
                  icon={getWhatToDoItemIconName(whatToDo)}
                  href={`/wat-te-doen-bij/${whatToDo.id}`}
                />
              ))}
          </ContentSection>
        </div>

        {flashNews && (
          <div className='grid grid-cols-1 xl:grid-cols-3 gap-8 mt-8'>
            <FlashNews flashNews={flashNews} />
          </div>
        )}
      </div>
    </ScreenWrapper>
  )
}

export default HomeScreen
